import { addDays, format, isSameDay, parseISO, startOfWeek } from "date-fns";

const DATE_PARAM_FORMAT = "yyyy-MM-dd";

export const toISODate = (date: Date): string =>
  format(date, DATE_PARAM_FORMAT);

export const mondayOf = (date: Date): Date =>
  startOfWeek(date, { weekStartsOn: 1 });

export const parseDateParam = (value: string | undefined): Date => {
  if (!value) return new Date();
  const parsed = parseISO(value);
  return Number.isNaN(parsed.getTime()) ? new Date() : parsed;
};

export const rangeDays = (anchor: Date, count: number): Date[] =>
  Array.from({ length: count }, (_, i) => addDays(anchor, i));

export const shiftDays = (date: Date, delta: number): Date =>
  addDays(date, delta);

export const formatWeekday = (date: Date): string => format(date, "EEE");

export const formatDayNumber = (date: Date): string => format(date, "d");

export const formatRange = (start: Date, end: Date): string => {
  if (isSameDay(start, end)) return format(start, "EEE, MMM d, yyyy");
  const sameMonth = format(start, "MMM yyyy") === format(end, "MMM yyyy");
  return sameMonth
    ? `${format(start, "MMM d")} – ${format(end, "d, yyyy")}`
    : `${format(start, "MMM d")} – ${format(end, "MMM d, yyyy")}`;
};
